import Vue from 'www/vue_components'
import vuetify from 'www/modules/vuetify-plugin'
import ChangeLanguageButton from 'www/vue_components/desktop/ChangeLanguage/ChangeLanguageButton.vue'

const mountElement = document.querySelector('#change-language-button')

if (mountElement) {
  new Vue({
    vuetify,
    el: mountElement,
    components: {
      ChangeLanguageButton,
    },
  })
}
